import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const pt: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizado',
    PAGE_SUBTITLE:
      'Visualize o consumo da plataforma de aprendizado. Cursos próprios vs catálogo Crehana, evolução trimestral, certificações e satisfação.',
    NEW_TAG: 'Novo',
    FRESHNESS_PREFIX: 'Última atualização:',
    PRODUCT_SELECTOR_LABEL: 'Produto',
    PRODUCT_SELECTOR_HELPER: 'Selecione o produto que deseja analisar',
    PRODUCT_GENERAL: 'Geral',
    PRODUCT_LEARNING: 'Aprendizado',
    BREADCRUMB_LEARNING: 'Aprendizado',
    TAB_GENERAL: 'Geral',
    TAB_PATHS: 'Por trilhas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuários',
    TAB_PLACEHOLDER_PATHS: 'Conteúdo de trilhas em breve',
    TAB_PLACEHOLDER_COURSES: 'Conteúdo de cursos em breve',
    TAB_PLACEHOLDER_USERS: 'Conteúdo de usuários em breve',
    EMPTY_TITLE: 'Nenhum módulo disponível',
    EMPTY_DESCRIPTION: 'Quando houver dados de aprendizado, você os verá aqui.',
    ERROR_TITLE: 'Erro ao carregar o dashboard',
    ERROR_RETRY: 'Tentar novamente',
    PERIOD_LABEL: 'Período',
    PERIOD_WEEK: 'Esta semana',
    PERIOD_MONTH: 'Este mês',
    PERIOD_QUARTER: 'Este trimestre',
    PERIOD_YEAR: 'Este ano',
    PERIOD_CUSTOM: 'Intervalo personalizado',
    PERIOD_HINT:
      'As métricas e tabelas são recalculadas com base no período selecionado',
    PERIOD_SELECT_ARIA: 'Selecionar período',
    PERIOD_RANGE_PLACEHOLDER: 'Selecione um intervalo',
    SEGMENT_BAR_LABEL: 'Segmentar por',
    SEGMENT_TRIGGER_PLACEHOLDER: 'Selecione um atributo',
    SEGMENT_SEARCH_PLACEHOLDER: 'Buscar atributo',
    SEGMENT_GROUP_DEFAULT: 'Predefinidos',
    SEGMENT_GROUP_CUSTOM: 'Personalizados',
    SEGMENT_MANAGE_ACTION: 'Gerenciar atributos',
    SEGMENT_LOADING: 'Carregando atributos…',
    SEGMENT_ERROR: 'Não foi possível carregar os atributos',
    SEGMENT_ERROR_RETRY: 'Tentar novamente',
    SEGMENT_EMPTY: 'Nenhum atributo disponível',
    SEGMENT_NO_RESULTS: 'Sem resultados',
    SEGMENT_SECTION_TITLE: 'Segmentação',
    SEGMENT_TAG_GRANULAR: 'Granular',
    SEGMENT_SECTION_DESC:
      'Reagrupe as métricas por qualquer atributo da sua empresa — os predefinidos da base de colaboradores ou os atributos personalizados que você configurou.',
    CERT_SECTION_TITLE: 'Certificados',
    CERT_SECTION_DESC:
      'Um certificado é emitido quando um usuário conclui um curso com certificação habilitada. Um mesmo usuário pode obter múltiplos certificados (um por curso concluído).',
    HISTORIC_CHIP: 'Histórico · não depende do período',
    CERT_KPI_TOTAL_LABEL: 'Certificados emitidos (Total)',
    CERT_DOWNLOAD_LINK_LABEL: 'Baixar certificados',
    CERT_KPI_USERS_LABEL: 'Usuários com pelo menos 1 certificado',
    CERT_KPI_AVG_LABEL: 'Média de certificados por usuário',
    CERT_CHART_TITLE: 'Certificados emitidos por mês',
    CERT_CHART_HELPER: 'Últimos 16 meses · Certificados emitidos por mês',
    CERT_CHART_BARS_LEGEND: 'Certificados',
    CSAT_SECTION_TITLE: 'Satisfação das Pesquisas — Rotas principais',
    CSAT_TABLE_TITLE: 'Satisfação das pesquisas por rota principal',
    CSAT_COL_ROUTE: 'Rota',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Média do CSAT dos cursos da rota. Diferente do rating individual de curso do bloco de métricas-chave.',
    CSAT_COL_RESPONSES: 'Respostas',
    CSAT_COL_UNIQUE_USERS: 'Usuários únicos',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'Sem rotas principais',
    CSAT_EMPTY_DESC: 'Nenhuma rota lançada nos últimos 90 dias.',
    CSAT_ERROR_TITLE: 'Erro ao carregar dados de CSAT',
    CSAT_ERROR_RETRY: 'Tentar novamente',
    // === ANLT-273 Activity Trends Section ===
    TRENDS_TENDENCIAS_SECTION_TITLE: 'Tendências',
    TRENDS_HISTORICO_CHIP: 'Histórico · não depende do período',
    TRENDS_NOTE_INSCRIPCION: 'Agrupado por data de inscrição',
    TRENDS_NOTE_ACTIVOS: 'Inclui apenas colaboradores ativos atuais',
    TRENDS_PROPIOS_CATALOGO_TITLE: 'Cursos Próprios vs Catálogo Crehana',
    TRENDS_PROPIOS_CATALOGO_HELPER:
      '**Próprio** = cursos enviados pela empresa · **Catálogo** = cursos da biblioteca Crehana. Gráfico mostra enrollments (inscrições) e concluídos por trimestre.',
    TRENDS_EVOLUCION_TITLE: 'Evolução Trimestral',
    TRENDS_EVOLUCION_HELPER:
      'Inscritos + Concluídos (barras) e % Conclusão (linha)',
    TRENDS_MENSUAL_TITLE: 'Tendência Mensal',
    TRENDS_MENSUAL_HELPER:
      'Últimos 15 meses · Inscritos, Usuários únicos e Concluídos',
    TRENDS_DETALLE_TITLE: 'Detalhe trimestral',
    TRENDS_DETALLE_HELPER: 'Mesmas métricas, valores absolutos · 5 trimestres',
    SERIES_PROPIO_ENR: 'Próprios - Inscritos',
    SERIES_CATALOGO_ENR: 'Catálogo - Inscritos',
    SERIES_PROPIO_COMP: 'Próprios - Concluídos',
    SERIES_CATALOGO_COMP: 'Catálogo - Concluídos',
    SERIES_ENROLLMENTS: 'Inscritos',
    SERIES_UNICOS: 'Usuários únicos',
    SERIES_COMPLETADOS: 'Concluídos',
    SERIES_COMPLETION: '% Conclusão',
    TABLE_PERIODO: 'Período',
    TABLE_ENROLLMENTS: 'Inscritos',
    TABLE_COMPLETADOS: 'Concluídos',
    TABLE_CERTIFICADOS: 'Certificados',
    TABLE_USUARIOS_UNICOS: 'Usuários únicos',
    TABLE_AVG_PROGRESS: 'Prog. Médio',
    TABLE_COMPLETION: '% Conclusão',

    // ── ANLT-279 · Rankings ──────────────────────────────────────────────
    RANK_LEARNERS_TITLE: 'Top Learners',
    RANK_CURSOS_TITLE: 'Top Cursos por Certificados',
    RANK_INACTIVOS_TITLE: 'Usuários inativos',
    RANK_INACTIVOS_CHIP: 'Sem acesso há 30+ dias',

    RANK_COL_RANK: '#',
    RANK_COL_NAME: 'Nome',
    RANK_COL_ENROLLMENTS: 'Inscrições',
    RANK_COL_COMPLETED: 'Concluídos',
    RANK_COL_CERTIFICATES: 'Certificados',
    RANK_COL_HOURS: 'Horas',
    RANK_COL_COURSE: 'Curso',
    RANK_COL_TYPE: 'Tipo',
    RANK_COL_USERS: 'Usuários',
    RANK_COL_DEPARTMENT: 'Departamento',
    RANK_COL_LOCATION: 'Sede',
    RANK_COL_LAST_ACTIVITY: 'Última atividade',
    RANK_COL_PENDING: 'Cursos pendentes',

    RANK_SOURCE_PROPIO: 'Próprio',
    RANK_SOURCE_CATALOGO: 'Catálogo',

    RANK_INACTIVOS_COUNT: '{{count}} colaboradores',
    RANK_INACTIVOS_SUMMARY:
      'sem acesso há mais de 30 dias · ordenados por inatividade',
    RANK_LAST_ACTIVITY_RELATIVE: 'Há {{count}} dias',
    RANK_LAST_ACTIVITY_NEVER: 'Nunca acessou',
    RANK_INACTIVOS_NOTE:
      'O envio de lembretes é gerenciado pelas Comunicações internas',
    RANK_INACTIVOS_LINK: 'Ver os {{count}} usuários inativos →',

    RANK_LEARNERS_EMPTY_TITLE: 'Sem dados de learners',
    RANK_LEARNERS_EMPTY_DESC:
      'Não há atividade de aprendizado no período selecionado.',
    RANK_CURSOS_EMPTY_TITLE: 'Sem dados de cursos',
    RANK_CURSOS_EMPTY_DESC:
      'Não há certificados emitidos no período selecionado.',
    RANK_INACTIVOS_EMPTY_TITLE: 'Sem usuários inativos',
    RANK_INACTIVOS_EMPTY_DESC:
      'Não há usuários sem acesso nos últimos 30 dias. Tudo ativo!',
    RANK_ERROR_TITLE: 'Erro ao carregar o ranking',
    RANK_ERROR_RETRY: 'Tentar novamente',
    // ANLT-275 — Trilhas de Aprendizagem (tabela)
    // ── ANLT-275 · Trilhas de Aprendizagem ───────────────────────────────
    LP_SECTION_HEADING: 'Trilhas de Aprendizagem',
    LP_FILTER_TIPO_LABEL: 'Tipo:',
    LP_FILTER_TIPO_ALL: 'Todas',
    LP_FILTER_TIPO_MANDATORY: 'Obrigatórias',
    LP_FILTER_TIPO_OPTIONAL: 'Opcionais',
    LP_FILTER_ORIGEN_LABEL: 'Origem:',
    LP_FILTER_ORIGEN_ALL: 'Todos',
    LP_FILTER_ORIGEN_OWN: 'Próprio',
    LP_FILTER_ORIGEN_CATALOG: 'Catálogo',
    LP_COL_PATH: 'Trilha',
    LP_COL_ENROLLED: 'Inscritos',
    LP_COL_COURSES_COMPLETED: 'Cursos concluídos',
    LP_COL_PATH_COMPLETED: 'Trilha concluída',
    LP_COL_COURSES_REQUIRED: 'Cursos req.',
    LP_COL_COMPLETION: '% Conclusão',
    LP_TABLE_EMPTY_TITLE: 'Sem dados de trilhas',
    LP_TABLE_EMPTY_DESC:
      'Nenhuma trilha de aprendizagem foi encontrada para o período selecionado.',
    LP_TABLE_ERROR_RETRY: 'Tentar novamente',
    // ── ANLT-271: KPI section — Métricas principais ───────────────────────────
    // ── ANLT-271 · KPI Section — Métricas principais ─────────────────────
    KPI_SECTION_HEADING: 'Métricas principais',
    KPI_SPARKLINE_A11Y: 'Tendência',
    KPI_ENGAGED_LABEL: 'Colaboradores engajados em Aprendizado',
    KPI_ENGAGED_HELP:
      'Colaboradores com atividade em cursos ou trilhas em {{period}}, sobre o total de colaboradores. Mede o quão ativa está a plataforma.',
    KPI_ENROLLMENTS_LABEL: 'Inscrições',
    KPI_ENROLLMENTS_HELP:
      'Total de inscrições em cursos acumuladas no ano (YTD). Inclui catálogo próprio e catálogo Crehana.',
    KPI_COMPLETIONS_LABEL: 'Concluídos',
    KPI_COMPLETIONS_HELP:
      'Cursos finalizados a 100% de visualização. A taxa de conclusão compara concluídos vs. iniciados.',
    KPI_COMPLETED_HOURS_LABEL: 'Horas concluídas',
    KPI_COMPLETED_HOURS_HELP:
      "Horas de reprodução (progresso × duração do curso) de colaboradores com atividade no período; corresponde à coluna 'Horas de Reprodução' do Relatório Geral. SCORM/conteúdo externo não registra reprodução.",
    KPI_CERTIFICATES_LABEL: 'Certificados emitidos',
    KPI_CERTIFICATES_DOWNLOAD_ACTION_TOOLTIP: 'Baixar certificados',
    KPI_CERTIFICATES_HELP:
      'Certificados gerados ao concluir um curso com certificação habilitada.',
    KPI_CSAT_LABEL: 'CSAT médio',
    KPI_CSAT_HELP:
      'Satisfação média (1–5) das pesquisas de fim de curso respondidas no período.',
    KPI_INACTIVE_LABEL: 'Usuários inativos (>30 dias)',
    KPI_INACTIVE_HELP:
      'Usuários ativos sem acesso à plataforma nos últimos 30 dias. Candidatos à reativação. O limite de 30 dias é fixo e não depende do período selecionado.',
    KPI_VS_PREV_PERIOD: 'vs período anterior',
    KPI_COMPLETION_RATE_SUFFIX: 'taxa de conclusão',
    KPI_SECTION_EMPTY_TITLE: 'Sem dados de aprendizado',
    KPI_SECTION_EMPTY_DESCRIPTION:
      'Quando houver métricas disponíveis, você as verá aqui.',
    KPI_SECTION_ERROR_RETRY: 'Tentar novamente',
    KPI_ENGAGED_FOOTER: 'Ativos com cursos/trilhas · Fonte: Learning events',
    KPI_ENROLLMENTS_FOOTER: 'Inscrições acumuladas',
    KPI_COMPLETIONS_FOOTER: 'Cursos finalizados em 100%',
    KPI_COMPLETED_HOURS_FOOTER:
      "Horas de reprodução (progresso × duração do curso) de colaboradores com atividade no período · corresponde à coluna 'Horas de Reprodução' do Relatório Geral",
    KPI_CERTIFICATES_FOOTER: 'Cursos com certificação habilitada',
    KPI_CSAT_FOOTER: 'Pesquisas pós-curso',
    KPI_INACTIVE_FOOTER: 'Sem acesso há mais de 30 dias',
    KPI_INACTIVE_LINK_LABEL: 'Ver lista',
    // Rich sublabels for KPIs that expose numerator/denominator (ANLT-271/272)
    KPI_ENGAGED_SUBLABEL_PREFIX: 'de {{denominator}} colaboradores',
    KPI_ENGAGED_SUBLABEL_HIGHLIGHT: 'engajamento',
    KPI_HOURS_SUBLABEL_SUFFIX: 'média · por colaborador ativo',
    KPI_CSAT_SUBLABEL_SUFFIX: 'respostas',
    KPI_INACTIVE_SUBLABEL_SUFFIX: 'de {{denominator}} colaboradores',
    // Crehana AI — CTA inline (ANLT-369) — rodapé de cada uma das 4 abas
    AI_CTA_BADGE: 'Crehana AI',
    AI_CTA_TITLE: 'Quer fazer alguma pergunta específica?',
    AI_CTA_DESCRIPTION:
      'Pergunte à Crehana AI sobre estes dados — conclusão, horas de estudo, usuários inativos, segmentação por área e mais.',
    AI_CTA_BUTTON: 'Pergunte à Crehana AI',
    // ── Aba "Por usuários" — faixa de KPIs (ANLT-296) ─────────────────────────
    USERS_KPI_SECTION_HEADING: 'Métricas de usuários',
    USERS_KPI_SECTION_ERROR_RETRY: 'Tentar novamente',
    USERS_ACTIVE_ONLY_BANNER:
      'As estatísticas da tabela incluem todos os colaboradores do relatório; a faixa "Usuários ativos" conta apenas os ativos no período. Dados em tempo quase real.',
    USERS_KPI_ACTIVE_LABEL: 'Usuários ativos',
    USERS_KPI_ACTIVE_HELP: 'Usuários com status ativo na plataforma.',
    USERS_KPI_STUDYING_LABEL: 'Usuários estudando',
    USERS_KPI_STUDYING_HELP:
      'Usuários com pelo menos um curso iniciado no período. É um subconjunto dos usuários ativos.',
    USERS_KPI_STUDYING_FOOTER: 'com ≥1 curso iniciado · {{period}}',
    USERS_KPI_HOURS_LABEL: 'Média de horas / usuário',
    USERS_KPI_HOURS_HELP:
      'Horas de estudo do período divididas pelos usuários ativos. Fonte: bioprogress (progresso × duração).',
    USERS_KPI_CERTIFICATE_LABEL: 'Usuários com ≥1 certificado',
    USERS_KPI_CERTIFICATE_HELP:
      'Usuários ativos que obtiveram pelo menos um certificado.',
    // ── Aba "Por usuários" — Segmentação / breakdown (ANLT-296) ───────────────
    USERS_KPI_CERTIFICATE_FOOTER: '{{num}} de {{den}} usuários ativos',
    USERS_SORT_LABEL: 'Ordenar por',
    USERS_SORT_HOURS: 'Horas de estudo',
    USERS_SORT_CERTIFICATES: 'Certificados',
    USERS_BREAKDOWN_HEADING: 'Segmentação',
    USERS_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    USERS_BREAKDOWN_DESC:
      'Reagrupe as métricas por qualquer atributo da sua empresa — os padrões da base de colaboradores ou os atributos personalizados que você configurou.',
    USERS_BREAKDOWN_CAPTION: '{{active}} ativos · {{studying}} estudando',
    USERS_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    // Shared prefix rendered to the LEFT of the active segment-filter chip on the
    // rutas/cursos/usuarios tables (ANLT-440): "Filtrado por: [chip]".
    SEGMENT_FILTER_PREFIX: 'Filtrado por:',
    USERS_BREAKDOWN_EMPTY:
      'Quando houver dados por segmento, você os verá aqui.',
    USERS_BREAKDOWN_ERROR:
      'Não foi possível carregar a segmentação de usuários.',
    USERS_BREAKDOWN_ERROR_RETRY: 'Tentar novamente',
    // ── Aba "Por trilhas" — Segmentação / medalheiro (ANLT-395) ────────────────
    ROUTES_SORT_LABEL: 'Ordenar por',
    ROUTES_SORT_COMPLETITUD: 'Completude',
    ROUTES_SORT_ROUTES_COMPLETED: '% trilhas concluídas',
    ROUTES_SORT_COURSES_COMPLETED: '% cursos concluídos',
    ROUTES_SORT_EVALUATIONS: '% avaliações',
    ROUTES_SORT_PROJECTS: '% projetos',
    ROUTES_SORT_USERS: 'Usuários',
    ROUTES_BREAKDOWN_HEADING: 'Segmentação',
    ROUTES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    ROUTES_BREAKDOWN_DESC:
      'Reagrupe as métricas de trilhas por qualquer atributo da sua empresa — os padrões da base de colaboradores ou os atributos personalizados que você configurou. A coorte de usuários por segmento é a coorte ativa, portanto não soma 1:1 em relação à faixa geral.',
    ROUTES_BREAKDOWN_CAPTION: '{{users}} usuários',
    ROUTES_BREAKDOWN_EMPTY:
      'Quando houver dados por segmento, você os verá aqui.',
    ROUTES_BREAKDOWN_ERROR:
      'Não foi possível carregar a segmentação de trilhas.',
    ROUTES_BREAKDOWN_ERROR_RETRY: 'Tentar novamente',
    // ── Aba "Por usuários" — Tabela de usuários / drawer (ANLT-298) ───────────
    USERS_TABLE_HEADING: 'Usuários',
    USERS_TABLE_COUNT_LABEL: 'Usuários',
    USERS_TABLE_COL_USER: 'Usuário',
    USERS_TABLE_COL_AREA: 'Área',
    USERS_TABLE_COL_COURSES: 'Cursos inscritos',
    USERS_TABLE_TOOLTIP_COURSES:
      'Conta as inscrições criadas dentro do período selecionado. Não é um total histórico.',
    USERS_TABLE_COL_ASSIGNED: 'Atribuídos',
    USERS_TABLE_COL_COMPLETED: 'Concluídos',
    USERS_TABLE_COL_PROGRESS: '% Avanço',
    USERS_TABLE_COL_ROUTES: 'Rotas',
    USERS_TABLE_COL_CERTIFICATES: 'Certif.',
    USERS_TABLE_COL_HOURS: 'Horas',
    USERS_TABLE_COL_LAST_ACTIVITY: 'Última atividade',
    USERS_TABLE_HOURS_VALUE: '{{hours}}h',
    USERS_TABLE_ACTIVITY_TODAY: 'Hoje',
    USERS_TABLE_ACTIVITY_YESTERDAY: 'Ontem',
    USERS_TABLE_ACTIVITY_DAYS_AGO: 'Há {{count}} dias',
    USERS_TABLE_SEARCH_PLACEHOLDER: 'Inserir nome de usuário',
    USERS_TABLE_EMPTY: 'Quando houver dados de usuários, você os verá aqui.',
    USERS_TABLE_NO_RESULTS: 'Nenhum usuário corresponde à sua busca.',
    USERS_TABLE_NEVER_LOGGED: 'Nunca acessou',
    USER_DETAIL_CLOSE: 'Fechar',
    USER_DETAIL_KPI_COMPLETED: 'Cursos concluídos',
    USER_DETAIL_KPI_ROUTES: 'Rotas concluídas',
    USER_DETAIL_KPI_CERTIFICATES: 'Certificados',
    USER_DETAIL_KPI_HOURS: 'Horas de estudo',
    USER_DETAIL_ROUTES_TITLE: 'Rotas em andamento',
    USER_DETAIL_ACTIVITY_TITLE: 'Atividade recente',
    USER_DETAIL_ACTIVITY_COMPLETED: 'Concluído',
    USER_DETAIL_ACTIVITY_IN_PROGRESS: 'Em andamento · {{progress}}%',
    USER_DETAIL_ROUTE_COURSES_FRACTION: '{{completed}} de {{assigned}} cursos',
    USER_DETAIL_VIEW_PROFILE: 'Ver perfil completo',
    USER_DETAIL_EMPTY: 'Este usuário ainda não tem dados para mostrar.',
    USERS_TABLE_EXPORT_REPORT: 'Exportar relatório',
    USERS_REPORT_GENERATION_SUCCESS: 'Relatório gerado com sucesso.',
    USERS_REPORT_GENERATION_SUCCESS_DESC:
      'Você encontrará este relatório na seção Relatórios.',
    USERS_REPORT_GENERATION_PENDING: 'Já existe um relatório sendo gerado',
    USERS_REPORT_GENERATION_ERROR: 'Não foi possível gerar o relatório',
    USERS_REPORT_GENERATION_ERROR_DESC:
      'Houve um problema ao gerar seu relatório. Por favor, tente novamente.',
    USERS_REPORT_PERMISSION_ERROR_TITLE:
      'Você não tem permissão para realizar esta ação',
    USERS_REPORT_PERMISSION_ERROR_DESC:
      'Seu cargo ou organização não permite gerar este relatório. Entre em contato com o administrador se acha que é um erro.',
    USERS_REPORT_RATE_LIMIT_TITLE: 'Máximo de tentativas por minuto',
    USERS_REPORT_RATE_LIMIT_DESC:
      'Você atingiu o limite de geração de relatórios por minuto. Aguarde alguns minutos antes de tentar novamente.',
    // Courses KPI band (ANLT-292/293) — active-only metrics
    COURSES_KPI_SECTION_HEADING: 'Métricas de cursos',
    COURSES_KPI_BANNER:
      'Aqui você encontrará todos os cursos que atribuiu dentro de trilhas ou como **cursos livres** aos seus usuários — catálogo próprio e catálogo Crehana.',
    COURSES_KPI_CATALOG_LABEL: 'Catálogo:',
    COURSES_KPI_CATALOG_ALL: 'Todos',
    COURSES_KPI_CATALOG_OWN: 'Próprios',
    COURSES_KPI_CATALOG_CREHANA: 'Crehana',
    COURSES_KPI_ACTIVE_LABEL: 'Cursos ativos',
    COURSES_KPI_ACTIVE_HELP:
      'Cursos atribuídos atualmente a usuários, dentro de trilhas ou como cursos livres. Inclui catálogo próprio e Crehana.',
    COURSES_KPI_ACTIVE_FOOTER:
      '{{own}} próprios · {{catalog}} do catálogo Crehana',
    COURSES_KPI_ENROLLMENTS_LABEL: 'Inscrições',
    COURSES_KPI_ENROLLMENTS_HELP:
      'Total de inscrições em cursos acumuladas no ano (YTD).',
    COURSES_KPI_ENROLLMENTS_FOOTER: 'acumuladas · {{period}}',
    COURSES_KPI_COMPLETED_LABEL: 'Concluídos',
    COURSES_KPI_COMPLETED_HELP:
      'Cursos finalizados com 100% de visualização no ano.',
    COURSES_KPI_COMPLETED_FOOTER: 'finalizados · {{period}}',
    COURSES_KPI_COMPLETION_RATE_LABEL: 'Taxa de conclusão',
    COURSES_KPI_COMPLETION_RATE_HELP:
      'Média de cursos concluídos sobre cursos iniciados. Mede a proporção de quem começa e termina.',
    COURSES_KPI_COMPLETION_RATE_FOOTER: 'média sobre cursos iniciados',
    COURSES_KPI_EMPTY_TITLE: 'Sem dados de cursos',
    COURSES_KPI_EMPTY_DESCRIPTION:
      'Quando houver métricas disponíveis, você as verá aqui.',
    COURSES_KPI_ERROR_RETRY: 'Tentar novamente',
    // ── ANLT-294 round-4: Cursos medallero + busca ────────────────────────────
    COURSES_SORT_LABEL: 'Ordenar por',
    COURSES_SORT_ENROLLMENTS: 'Inscrições',
    COURSES_SORT_COMPLETED: 'Concluídos',
    COURSES_SORT_COMPLETION_RATE: 'Taxa de conclusão',
    COURSES_BREAKDOWN_HEADING: 'Segmentação',
    COURSES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    COURSES_BREAKDOWN_DESC:
      'Reagrupe as métricas de cursos por qualquer atributo da sua empresa — os padrões da base de colaboradores ou os atributos personalizados que você configurou.',
    COURSES_BREAKDOWN_CAPTION: '{{active}} ativos · {{started}} iniciados',
    COURSES_BREAKDOWN_EMPTY:
      'Quando houver dados por segmento, você os verá aqui.',
    COURSES_BREAKDOWN_ERROR:
      'Não foi possível carregar a segmentação de cursos.',
    COURSES_BREAKDOWN_ERROR_RETRY: 'Tentar novamente',
    COURSES_TABLE_SEARCH_PLACEHOLDER: 'Buscar curso',
    COURSES_TABLE_NO_RESULTS_TITLE: 'Sem resultados',
    COURSES_TABLE_NO_RESULTS_DESCRIPTION:
      'Não encontramos cursos que correspondam à sua busca.',
    // Courses table + drawer (ANLT-294)
    COURSES_TABLE_SECTION_HEADING: 'Detalhe de cursos',
    COURSES_TABLE_TITLE: 'Cursos',
    COURSES_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    COURSES_TABLE_COL_COURSE: 'Curso',
    COURSES_TABLE_COL_TYPE: 'Tipo',
    COURSES_TABLE_COL_ENROLLED: 'Inscritos',
    COURSES_TABLE_COL_STARTED: 'Iniciaram',
    COURSES_TABLE_COL_COMPLETED: 'Concluídos',
    COURSES_TABLE_COL_EVAL_APPROVED: 'Aval. aprov.',
    COURSES_TABLE_COL_PROGRESS: '% Progresso',
    COURSES_TABLE_COL_REPRODUCTION_HOURS: 'Horas reprod.',
    COURSES_TABLE_COL_CERTIFICATES: 'Certif.',
    COURSES_TABLE_COL_CSAT: 'CSAT',
    COURSES_TABLE_TOOLTIP_ENROLLED:
      'Conta inscrições (um usuário pode ter mais de uma), igual ao relatório de Cursos.',
    COURSES_TABLE_TOOLTIP_EVAL_APPROVED:
      'Porcentagem de avaliações aprovadas sobre o total de avaliações realizadas.',
    COURSES_TABLE_TOOLTIP_REPRODUCTION_HOURS:
      'Horas totais de vídeo reproduzidas pelos usuários inscritos no curso.',
    COURSES_TABLE_TOOLTIP_CSAT:
      'Média de satisfação relatada pelos usuários que responderam à pesquisa pós-curso.',
    COURSES_TABLE_CSAT_EMPTY: 'Sem dados',
    COURSES_TABLE_EMPTY_TITLE: 'Sem cursos para este período',
    COURSES_TABLE_EMPTY_DESCRIPTION:
      'Não encontramos cursos que correspondam ao período selecionado.',
    COURSES_TABLE_ERROR_TITLE: 'Não foi possível carregar a tabela',
    COURSES_TABLE_ERROR_DESCRIPTION:
      'Ocorreu um erro ao obter os cursos. Tente novamente.',
    COURSES_TABLE_ERROR_RETRY: 'Tentar novamente',
    // ── ANLT-294 round-3: "Exportar relatório" (REPORT_B2B_COURSES) ───────────
    COURSES_TABLE_EXPORT_ACTION: 'Exportar relatório',
    COURSES_TABLE_EXPORT_STARTED_TITLE:
      'Gerando relatório...isso pode levar alguns minutos',
    COURSES_TABLE_EXPORT_STARTED_DESC:
      'Você encontrará este relatório na seção de Relatórios quando terminar.',
    COURSES_TABLE_EXPORT_PENDING: 'Já existe um relatório sendo gerado',
    COURSES_TABLE_EXPORT_ERROR_TITLE: 'Não foi possível gerar o relatório',
    COURSES_TABLE_EXPORT_ERROR_DESC:
      'Houve um problema ao gerar seu relatório. Por favor, tente novamente.',
    COURSES_TABLE_EXPORT_PERMISSION_TITLE:
      'Você não tem permissão para realizar esta ação',
    COURSES_TABLE_EXPORT_PERMISSION_DESC:
      'Seu cargo ou organização não permite gerar este relatório. Entre em contato com o administrador se acha que é um erro.',
    COURSES_TABLE_EXPORT_RATE_LIMIT_TITLE: 'Máximo de tentativas por minuto',
    COURSES_TABLE_EXPORT_RATE_LIMIT_DESC:
      'Você atingiu o limite de geração de relatórios por minuto. Aguarde alguns minutos antes de tentar novamente.',
    COURSES_TABLE_SOURCE_OWN: 'Próprio',
    COURSES_TABLE_SOURCE_CATALOG: 'Catálogo',
    COURSES_TABLE_DRAWER_PERFORMANCE_HEADING: 'Desempenho do curso',
    COURSES_TABLE_DRAWER_SATISFACTION_HEADING: 'Satisfação',
    COURSES_TABLE_DRAWER_TOP_USERS_HEADING: 'Top de usuários',
    COURSES_TABLE_DRAWER_CSAT_RESPONSES: 'Com base em {{count}} respostas',
    COURSES_TABLE_DRAWER_CSAT_AVERAGE: 'CSAT médio',
    COURSES_TABLE_DRAWER_CLOSE: 'Fechar',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_USER: 'Usuário',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_PROGRESS: '% Progresso',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_POSITION: 'Posição',
    COURSES_TABLE_DRAWER_TOP_USERS_SEARCH: 'Buscar usuário',
    COURSES_TABLE_DRAWER_VIEW_PROFILE: 'Ver perfil completo',
    COURSES_TABLE_DRAWER_KPI_ENROLLED_LABEL: 'Inscritos',
    COURSES_TABLE_DRAWER_KPI_COMPLETED_LABEL: 'Concluídos',
    COURSES_TABLE_DRAWER_KPI_COMPLETION_RATE_LABEL: 'Taxa de conclusão',
    COURSES_TABLE_DRAWER_KPI_REPRODUCTION_HOURS_LABEL: 'Horas reprod.',
    COURSES_TABLE_DRAWER_ERROR: 'Não foi possível carregar o detalhe do curso.',
    // ── ANLT-288: Routes KPI section — Estado atual das trilhas ──────────────
    ROUTES_KPI_SECTION_HEADING: 'Progresso total de trilhas',
    ROUTES_KPI_SECTION_ERROR_RETRY: 'Tentar novamente',
    ROUTES_KPI_COMPLETITUD_TOTAL_LABEL: 'Conclusão total',
    ROUTES_KPI_COMPLETITUD_TOTAL_HELP:
      'Percentual médio de avanço de todas as trilhas atribuídas aos colaboradores.',
    ROUTES_KPI_COMPLETITUD_TOTAL_FOOTER: 'Média de avanço das trilhas',
    ROUTES_KPI_ROUTES_COMPLETED_LABEL: 'Trilhas concluídas',
    ROUTES_KPI_ROUTES_COMPLETED_HELP:
      'Percentual de trilhas atribuídas concluídas a 100% pelos colaboradores.',
    ROUTES_KPI_ROUTES_COMPLETED_FOOTER: 'Trilhas com 100% de avanço',
    ROUTES_KPI_COURSES_COMPLETED_LABEL: 'Cursos concluídos',
    ROUTES_KPI_COURSES_COMPLETED_HELP:
      'Percentual de cursos dentro de trilhas concluídos a 100% pelos colaboradores.',
    ROUTES_KPI_COURSES_COMPLETED_FOOTER: 'Cursos finalizados dentro de trilhas',
    ROUTES_KPI_EVALUATIONS_APPROVED_LABEL: 'Avaliações aprovadas',
    ROUTES_KPI_EVALUATIONS_APPROVED_HELP:
      'Percentual de avaliações de trilhas aprovadas sobre o total de avaliações realizadas.',
    ROUTES_KPI_EVALUATIONS_APPROVED_FOOTER: 'Avaliações aprovadas em trilhas',
    ROUTES_KPI_PROJECTS_APPROVED_LABEL: 'Projetos aprovados',
    ROUTES_KPI_PROJECTS_APPROVED_HELP:
      'Percentual de projetos de trilhas aprovados sobre o total de projetos entregues.',
    ROUTES_KPI_PROJECTS_APPROVED_FOOTER: 'Projetos aprovados em trilhas',
    // ── ANLT-290: Routes deep-dive table columns ──────────────────────────────
    RDD_COL_ROUTE: 'Trilha',
    RDD_COL_ENROLLED: 'Inscritos',
    RDD_COL_COMPLETION: 'Avanço',
    RDD_COL_COURSES_REQUIRED: 'Cursos obrig.',
    RDD_COL_ROUTE_COMPLETED: 'Trilha concluída',
    RDD_COL_EVALUATIONS: 'Avaliações',
    RDD_COL_PROJECTS: 'Projetos da trilha',
    RDD_COL_CSAT: 'CSAT',
    RDD_COL_STATUS: 'Status',
    RDD_CSAT_NO_DATA: 'Sem dados',
    RDD_STATUS_ACTIVE: 'Ativa',
    RDD_STATUS_ARCHIVED: 'Arquivada',
    RDD_STATUS_EMPTY: 'Sem inscritos',
    // ── ANLT-290: Route detail drawer ──────────────────────────────────────────
    RDD_DRAWER_TITLE: 'Detalhe da trilha',
    RDD_DRAWER_SUBTITLE:
      '{{courses}} cursos · {{evaluations}} avaliações · {{projects}} projetos',
    RDD_DRAWER_CLOSE: 'Fechar',
    RDD_DRAWER_ERROR_RETRY: 'Tentar novamente',
    RDD_DRAWER_COMPLETION_TITLE: 'Conclusão da trilha',
    RDD_DRAWER_KPI_ENROLLED: 'Usuários inscritos',
    RDD_DRAWER_KPI_AVG_PROGRESS: 'Progresso médio',
    RDD_DRAWER_KPI_COURSES_REQUIRED: 'Cursos obrigatórios',
    RDD_DRAWER_KPI_EVALUATIONS: 'Avaliações',
    RDD_DRAWER_KPI_PROJECTS: 'Projetos da trilha',
    RDD_DRAWER_COURSES_TITLE: 'Cursos da trilha',
    RDD_DRAWER_COURSES_COMPLETED: '{{count}} concluídos',
    RDD_DRAWER_TOP_USERS_TITLE: 'Top usuários na trilha',
    RDD_DRAWER_TOP_USERS_COL_POSITION: 'Posição',
    RDD_DRAWER_TOP_USERS_COL_USER: 'Usuário',
    RDD_DRAWER_TOP_USERS_COL_PROGRESS: '% Progresso',
    RDD_DRAWER_TOP_USERS_SEARCH: 'Buscar usuário',
    RDD_DRAWER_VIEW_PROFILE: 'Ver perfil completo',
    RDD_DRAWER_EMPTY: 'Não há informações para exibir.',
    // ── ANLT-290: Routes deep-dive section shell ──────────────────────────────
    RDD_SECTION_HEADING: 'Detalhamento por trilhas',
    RDD_TABLE_TITLE: 'Trilhas',
    RDD_EMPTY_TITLE: 'Ainda não há dados de trilhas',
    RDD_EMPTY_DESC: 'Não encontramos trilhas para o período selecionado.',
    RDD_ERROR_RETRY: 'Tentar novamente',
    // ── ANLT-290 round-3: search + export ─────────────────────────────────────
    RDD_TABLE_SEARCH_PLACEHOLDER: 'Buscar trilha',
    RDD_TABLE_NO_RESULTS: 'Nenhuma trilha corresponde à sua busca.',
    RDD_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    RDD_EXPORT_BUTTON: 'Exportar relatório',
    RDD_EXPORT_STARTED_TITLE: 'Estamos gerando seu relatório',
    RDD_EXPORT_STARTED_DESC:
      'Você poderá baixá-lo na seção Relatórios em alguns minutos.',
    RDD_EXPORT_PENDING: 'Já existe um relatório sendo gerado.',
    RDD_EXPORT_ERROR_TITLE: 'Não foi possível gerar seu relatório',
    RDD_EXPORT_ERROR_DESC: 'Tente novamente em alguns minutos.',
    RDD_EXPORT_RATE_LIMIT_TITLE: 'Máximo de tentativas por minuto',
    RDD_EXPORT_RATE_LIMIT_DESC: 'Aguarde um momento antes de tentar novamente.',
    RDD_EXPORT_PERMISSION_TITLE: 'Você não tem permissão para esta ação',
    RDD_EXPORT_PERMISSION_DESC:
      'Entre em contato com um administrador se achar que isso é um erro.',
    // ── ANLT-466 · Horas de estudo (heatmap) ───────────────────────────────
    STUDY_HOURS_CARD_TITLE: 'Horas de estudo',
    STUDY_HOURS_CARD_DESCRIPTION:
      'Atividade de estudo da sua organização por semana, mês e ano.',
    STUDY_HOURS_TAB_WEEKLY: 'Semanal',
    STUDY_HOURS_TAB_MONTHLY: 'Mensal',
    STUDY_HOURS_TAB_YEARLY: 'Anual',
    STUDY_HOURS_TAB_WEEKLY_AXIS_LEFT: 'Dia',
    STUDY_HOURS_TAB_WEEKLY_AXIS_TOP: 'Hora',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT: 'Semanas do mês',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT_TOOLTIP: 'Semana do mês',
    STUDY_HOURS_TAB_MONTHLY_AXIS_TOP: 'Meses do ano',
    STUDY_HOURS_TAB_YEARLY_AXIS_LEFT: 'Ano',
    STUDY_HOURS_TAB_YEARLY_AXIS_TOP: 'Mês',
    STUDY_HOURS_INSIGHT_DAY:
      '{{moment}} é seu dia com mais atividade, com {{hours}} horas de estudo',
    STUDY_HOURS_INSIGHT_MONTH:
      '{{moment}} foi seu mês com mais atividade, com {{hours}} horas de estudo',
    STUDY_HOURS_INSIGHT_YEAR:
      '{{moment}} foi seu ano com mais atividade, com {{hours}} horas de estudo',
    STUDY_HOURS_INSIGHT_EMPTY:
      'Ainda não há atividade suficiente para mostrar um insight',
    STUDY_HOURS_KPI_TOTAL_LABEL: 'Horas de estudo em total',
    STUDY_HOURS_KPI_TOTAL_TOOLTIP:
      'Soma das horas de reprodução da sua organização no período selecionado.',
    STUDY_HOURS_KPI_AVG_LABEL: 'Horas médias por aluno',
    STUDY_HOURS_KPI_AVG_TOOLTIP:
      'Horas de reprodução divididas pelos alunos com atividade no período selecionado.',
    STUDY_HOURS_KPI_VS_WEEK: 'vs semana anterior',
    STUDY_HOURS_KPI_VS_MONTH: 'vs mês anterior',
    STUDY_HOURS_KPI_VS_YEAR: 'vs ano anterior',
    STUDY_HOURS_LEGEND_1: 'Sem atividade',
    STUDY_HOURS_LEGEND_2: 'Baixa',
    STUDY_HOURS_LEGEND_3: 'Intermediária',
    STUDY_HOURS_LEGEND_4: 'Alta',
    STUDY_HOURS_LEGEND_TOOLTIP:
      'A intensidade da cor indica quantas horas de estudo houve nessa célula.',
    STUDY_HOURS_CELL_TOOLTIP_LABEL: 'Horas de estudo:',
    STUDY_HOURS_EMPTY_TITLE: 'Sem atividade de estudo',
    STUDY_HOURS_EMPTY_DESCRIPTION:
      'Não há horas de estudo registradas no período selecionado.',
    STUDY_HOURS_ERROR_RETRY: 'Tentar novamente',
  },
};
